import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { logoutUser } from '../firebase/auth';
import './Pending.css';

const PendingPage = () => {
  const { user, profile } = useAuth();

  const handleLogout = async () => {
    await logoutUser(user?.uid);
    window.location.href = '/login';
  };

  return (
    <div className="page pending-page">
      <div className="pending-card">
        <h2>⏳ Awaiting Approval</h2>
        <p>
          Hi <strong>{profile?.displayName || user?.email}</strong>,
        </p>
        <p>
          Your account has been created but is <strong>pending admin approval</strong>.
        </p>
        <p>
          You'll receive access once an admin approves your account. If you believe this is an error, contact your administrator.
        </p>
        <button className="btn-secondary" onClick={handleLogout}>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default PendingPage;
